import { CHANNEL, COUNTRIES } from 'config'

export const generateMediaUrlV2 = (src: string, png?: boolean) => {
  if (!src) {
    return undefined
  }
  if (src.endsWith('.mp4')) {
    return src
  }
  return `${src}?w={size}&f=webp`
}

export const getRegion = (country: string) => {
  switch (country.toLowerCase()) {
    case 'int':
      return 'INT'
    case 'us':
      return 'US'
    case 'gb':
      return 'GB'
    default:
      return 'EU'
  }
}

export const getCountryConfig = (country: string) => {
  return COUNTRIES.find((c) => c.code.toLowerCase() === country?.toLowerCase())
}
export const getCurrencyFromCountry = (country: string): string => {
  switch (country?.toUpperCase()) {
    case 'DK':
      return 'DKK'
  }
  const countryConfig = getCountryConfig(country)
  switch (countryConfig?.channel) {
    case CHANNEL.EUROPE:
      return 'EUR'
    case CHANNEL.UNITED_KINGDOM:
      return 'GBP'
    default:
      return 'USD'
  }
}
